var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1917_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4862 17.3186H14.5229V12.6777C14.5229 11.5711 14.5031 10.1465 12.9816 10.1465C11.4382 10.1465 11.202 11.3522 11.202 12.5972V17.3183H8.23875V7.77482H11.0835V9.07903H11.1234C11.4081 8.59224 11.8195 8.19178 12.3137 7.9203C12.808 7.64881 13.3667 7.51648 13.9302 7.53739C16.9338 7.53739 17.4875 9.51302 17.4875 12.0832L17.4862 17.3186ZM4.895 6.47036C3.94523 6.47052 3.17516 5.70067 3.175 4.75091C3.17484 3.80114 3.94461 3.03106 4.89437 3.03091C5.84414 3.03067 6.61422 3.80052 6.61437 4.75028C6.61446 5.20638 6.43336 5.64383 6.11092 5.96641C5.78847 6.28898 5.3511 6.47026 4.895 6.47036ZM6.37672 17.3186H3.41023V7.77482H6.37664V17.3186L6.37672 17.3186ZM18.9636 0.278799H1.92117C1.1157 0.269737 0.455156 0.914971 0.445312 1.72044V18.834C0.454844 19.6398 1.11531 20.2857 1.92109 20.2772H18.9636C19.7711 20.2872 20.4341 19.6414 20.4453 18.834V1.71911C20.4338 0.912081 19.7707 0.266924 18.9636 0.277471",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1917_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.445312 0.277344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.4e9f2dd88edac200f5c13ad57f312922.svg";
export { ForwardRef as ReactComponent };